import React from "react";

export function Input({ className = "", ...props }) {
  return (
    <input
      className={`border rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400 ${className}`}
      {...props}
    />
  );
}
